import { Component, OnInit } from '@angular/core';

import { Observable } from 'rxjs';
import { ProfileService } from './profile.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-page-ribbon',
  standalone: false,
  template: `
    <div class="ribbon" *ngIf="ribbonEnv$ | async as ribbonEnv">
      <a href="" [translate]="'global.ribbon.' + ribbonEnv">{{ ribbonEnv }}</a>
    </div>
  `,
  styleUrls: ['page-ribbon.scss'],
})
export class PageRibbonComponent implements OnInit {
  ribbonEnv$?: Observable<string | undefined>;

  constructor(private profileService: ProfileService) {}

  ngOnInit(): void {
    this.ribbonEnv$ = this.profileService
      .getProfileInfo()
      .pipe(map((profileInfo) => profileInfo.ribbonEnv));
  }
}
